import React from "react";
import { Link } from "react-router-dom";
import {
	Avatar,
	Button,
	Grid,
	IconButton,
	Stack,
	Tooltip,
	Typography,
} from "@mui/material";
import { DebtContext } from "../../../Context/DebtContext";
import AddCard from "../../../Templates/cardAdd";
import InsidePage from "../../../Templates/InsidePage";
import AdminConceptsCard from "./Card";
import deleteIcon from "../../../sources/Icons/deleteIcon.svg";

export default function AdminConceptGroupComponent() {
	const {
		getConceptGroups,
		staged,
		DebtData,
		RestartStaged,
		DeleteConceptGroup,
	} = DebtContext();
	React.useEffect(() => {
		getConceptGroups();
		console.log("admin DebtData", DebtData);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [deleteMode, setDeleteMode] = React.useState(false);

	function BottomBarDefault() {
		return (
			<>
				<Tooltip title="Borrar conceptos" arrow>
					<IconButton
						onClick={() => setDeleteMode(true)}
						variant="noPadding"
					>
						<Avatar variant="icon30x30" src={deleteIcon} />
					</IconButton>
				</Tooltip>
				<Button
					sx={{ minWidth: "250px", maxHeight: "30px" }}
					variant="contained"
					LinkComponent={Link}
					to="/admin/Conceptos"
				>
					Conceptos
				</Button>
			</>
		);
	}

	function BottomBarDelete() {
		return (
			<Stack
				direction="row"
				sx={{ width: "100%", justifyContent: "space-between" }}
			>
				<Stack
					spacing={1}
					direction="row"
					sx={{
						alignItems: "center",
					}}
				>
					<Tooltip title="Borrar conceptos" arrow>
						<IconButton
							onClick={() => setDeleteMode(true)}
							variant="noPadding"
						>
							<Avatar variant="icon30x30" src={deleteIcon} />
						</IconButton>
					</Tooltip>
					<Typography>Selecciona los conceptos a eliminar</Typography>
					<Typography fontWeight="bold">
						{staged.length}&nbsp;seleccionado(s)
					</Typography>
				</Stack>
				<Stack spacing={1} direction="row">
					<Button
						sx={{ minWidth: "250px", maxHeight: "30px" }}
						variant="contained"
						onClick={() => {
							DeleteConceptGroup();
							setDeleteMode(false);
							RestartStaged();
						}}
					>
						Eliminar seleccionados
					</Button>
					<Button
						sx={{ minWidth: "250px", maxHeight: "30px" }}
						variant="outlined"
						onClick={() => {
							RestartStaged();
							setDeleteMode(false);
						}}
					>
						Cancelar
					</Button>
				</Stack>
			</Stack>
		);
	}

	return (
		<InsidePage title="Grupo de Conceptos" visibility="hidden">
			<Grid container spacing={2}>
				{DebtData.conceptGroups?.map((concept) => (
					<Grid key={concept.uuid} item xs={4}>
						<AdminConceptsCard
							deleteMode={deleteMode}
							concept={concept}
						/>
					</Grid>
				))}
				<Grid item xs={4}>
					<AddCard to="/admin/GruposConceptos/crear" />
				</Grid>
			</Grid>
			<Stack spacing={1} direction="row" variant="BottomSelector">
				{deleteMode ? <BottomBarDelete /> : <BottomBarDefault />}
			</Stack>
		</InsidePage>
	);
}
